/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePolicyFeaturesMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdatePolicyFeaturesInput;
}>;


export type UpdatePolicyFeaturesMutation = { __typename?: 'Mutation', updatePolicyFeatures: { __typename?: 'PolicyFeatures', id: string, ownOccupationPolicy: boolean, residualDisabilityPolicy: boolean, noncancellable: boolean } | null };


export const UpdatePolicyFeaturesDocument = gql`
    mutation UpdatePolicyFeatures($input: UpdatePolicyFeaturesInput!) {
  updatePolicyFeatures(input: $input) {
    id
    ownOccupationPolicy
    residualDisabilityPolicy
    noncancellable
  }
}
    `;
export type UpdatePolicyFeaturesMutationFn = Apollo.MutationFunction<UpdatePolicyFeaturesMutation, UpdatePolicyFeaturesMutationVariables>;
export function useUpdatePolicyFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePolicyFeaturesMutation, UpdatePolicyFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePolicyFeaturesMutation, UpdatePolicyFeaturesMutationVariables>(UpdatePolicyFeaturesDocument, options);
      }
export type UpdatePolicyFeaturesMutationHookResult = ReturnType<typeof useUpdatePolicyFeaturesMutation>;
export type UpdatePolicyFeaturesMutationResult = Apollo.MutationResult<UpdatePolicyFeaturesMutation>;
export type UpdatePolicyFeaturesMutationOptions = Apollo.BaseMutationOptions<UpdatePolicyFeaturesMutation, UpdatePolicyFeaturesMutationVariables>;